import React from 'react';
import { SocialSharePlatformProvider } from '../SocialSharePlatformContext';
import { SocialSharePlatformProviderProps } from '../types';
import useThreadsSocialShare from './useThreadsSocialShare';

const ThreadsSocialShareProvider: React.FC<SocialSharePlatformProviderProps> = ({
  children,
}) => {
  const platformData = useThreadsSocialShare();

  return (
    <SocialSharePlatformProvider value={platformData}>
      {children}
    </SocialSharePlatformProvider>
  );
};

export default ThreadsSocialShareProvider;
